import { JSONContent } from "@tiptap/react";

export type Settings = {
  supersetsEnabled: boolean;
  soundsEnabled: boolean;
};

export const DEFAULT_SETTINGS: Settings = {
  supersetsEnabled: true,
  soundsEnabled: true,
};

export type WorkoutDocument = {
  id: string;
  created: Date;
  data: JSONContent;
  isTemplate: boolean;
  isShared: boolean;
  isEditable: boolean;
};

export type Workout = {
  exercises: Array<Exercise>;
  title: string;
  stale?: boolean;
};

export type ParsedWorkoutDocument = WorkoutDocument & {
  workout: Workout;
};

export type Exercise = {
  exerciseId: string;
  index: number;
  name: string;
  selected: boolean;
  history: boolean;
  sets: Array<Set>;
  targetSets: Array<Set>;
  superset: number;
};

export type Set = {
  complete: boolean;
  reps: number;
  selected: boolean;
  weight: number | null;
  seconds: number | null;
};

export type SetIndex = {
  exerciseIndex: number;
  setIndex: number;
};
